import { FunctionComponent, Suspense } from 'react';
import { BrowserRouter } from 'react-router-dom';
import Pages from './pages';
import ProblemStatusesProvider from 'providers/problem-statuses';
import LoadingProvider from 'providers/loading';
import AuthProvider from 'providers/auth';
import CitiesProvider from 'providers/cities';
import CategoriesProvider from 'providers/categories';
import NotificationsProvider from 'providers/notifications';
import { QueryParamProvider } from 'use-query-params';
import { ReactRouter6Adapter } from 'use-query-params/adapters/react-router-6';

interface AppProps {}

const App: FunctionComponent<AppProps> = () => {
  return (
    <Suspense fallback=''>
      <BrowserRouter>
        <QueryParamProvider adapter={ReactRouter6Adapter}>
          <NotificationsProvider>
            <CitiesProvider>
              <AuthProvider>
                <LoadingProvider>
                  <CategoriesProvider>
                    <ProblemStatusesProvider>
                      <Pages />
                    </ProblemStatusesProvider>
                  </CategoriesProvider>
                </LoadingProvider>
              </AuthProvider>
            </CitiesProvider>
          </NotificationsProvider>
        </QueryParamProvider>
      </BrowserRouter>
    </Suspense>
  );
};

export default App;
